const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnQuitXs(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.313 108.148a.993.993 0 0 1-.291.7l-3.131 3.132a.994.994 0 0 1-1.4-1.405l1.436-1.436h-6.213a.994.994 0 0 1 0-1.988h6.21l-1.433-1.432a.994.994 0 0 1 1.4-1.406l3.131 3.13a.994.994 0 0 1 .291.705zm-9.306 5.512h-3.7v-11.024h3.7a.994.994 0 0 0 0-1.988h-4.281a1.081 1.081 0 0 0-.127.008 1.466 1.466 0 0 0-1.283 1.551v11.881a1.464 1.464 0 0 0 1.283 1.55.9.9 0 0 0 .127.009h4.281a.994.994 0 0 0 0-1.988z",
    transform: "translate(-658.313 -95.648)",
    style: {
      fill: "current"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnQuitXs);
export default __webpack_public_path__ + "static/media/btn-quit-xs.6135ff49ad21e2f7fc935e5162357746.svg";
export { ForwardRef as ReactComponent };